import { ACTION_TYPES } from "src/constants";
import { INITIAL_STATE } from "../store";

export default function AdminBatchUploadReducer(
  state = INITIAL_STATE.adminIsBatchUploaded,
  action
) {
  switch (action.type) {
    case ACTION_TYPES.BATCH_UPLOAD_SUCCESS:
      return {
        ...state,
        adminIsBatchUploaded: action.payload,
      };

    case ACTION_TYPES.BATCH_UPLOAD_FAILED:
      return INITIAL_STATE.adminIsBatchUploaded;

    case ACTION_TYPES.REQUEST_ADMIN_LOGIN:
    case ACTION_TYPES.REQUEST_ADMIN_LOGOUT:
    case ACTION_TYPES.ADMIN_LOGOUT_SUCCESS:
      return INITIAL_STATE.adminIsBatchUploaded;

    default:
      return state;
  }
}
